import { render } from "./ZhilLiaoView.vue?vue&type=template&id=fecf54b2&scoped=true&ts=true"
import script from "./ZhilLiaoView.vue?vue&type=script&lang=ts"
export * from "./ZhilLiaoView.vue?vue&type=script&lang=ts"

import "./ZhilLiaoView.vue?vue&type=style&index=0&id=fecf54b2&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\fushuliang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fecf54b2"]])

export default __exports__